//https://dev.to/vinomanick/create-a-typescript-utility-library-using-vite-916
//https://github.com/jasonsturges/vite-typescript-npm-package

export const add = (a: number, b: number) => a + b
export const sub = (a: number, b: number) => a - b  